import {
    takeLatest, all, put, call, take, fork,
} from 'redux-saga/effects';
import { useHistory, useParams } from 'react-router-dom';
import { eventChannel, END } from 'redux-saga';
import _ from 'lodash';
import API from '../common/API';
import * as Actions from '../actions/AdminCompanyManagement';
import { waitAuthorizedCheck } from './Auth';

function* getDetailCompany(action) {
    const credential = yield call(waitAuthorizedCheck);
    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/organizer/${action.payload.company_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailCompanyReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailCompanyReceiveFailure(yield error));
    }
}

function* editDetailCompany(action) {
    const credential = yield call(waitAuthorizedCheck);
    try {
        const response = yield call(
            API.putWithFile,
            {
                endpoint: `/api/v1/event/${action.payload && action.payload.event_name}/organizer/${action.payload && action.payload.company_id}/`,
                body: {
                    ...(action.payload.fullName && { company_full_name: action.payload.fullName }),
                    ...(action.payload.fullNameEN && { company_full_name_en: action.payload.fullNameEN }),
                    ...(action.payload.shortName && { company_short_name: action.payload.shortName }),
                    ...(action.payload.shortNameEN && { company_short_name_en: action.payload.shortNameEN }),
                    ...(action.payload.companyType && { company_type: action.payload.companyType }),
                    ...(action.payload.companyCategory && { companyCategory: action.payload.companyCategory }),
                    company_url: action.payload.url,
                    company_description: action.payload.description,
                    company_description_en: action.payload.descriptionEN,
                    ...(action.payload.image && action.payload.isChangeImage && { company_image: action.payload.image }),
                    ...(!action.payload.image && action.payload.isChangeImage && { remove_image: 1 }),
                    ...(action.payload.firstName && { first_name: action.payload.firstName }),
                    ...(action.payload.lastName && { last_name: action.payload.lastName }),
                    department: action.payload.department,
                    position: action.payload.position,
                    location: action.payload.location,
                    employee_number: action.payload.employee_number,
                    ...(action.payload.zipCode && { zip_code: action.payload.zipCode }),
                    ...(action.payload.address && { address: action.payload.address }),
                    ...(action.payload.addressEN && { address_en: action.payload.addressEN }),
                    phone_number: action.payload.phoneNumber,
                    fax_number: action.payload.faxNumber,
                    ...(action.payload.booth_change > 0 && { booth: action.payload.booth }),
                    ...(action.payload.register_ads_max_change > 0 && { register_ads_max: action.payload.register_ads_max }),
                    ...(action.payload.seminars_change > 0 && { seminars: JSON.stringify(action.payload.seminars) }),
                    ...(action.payload.zone && { zone: action.payload.zone }),
                    ...(action.payload.optionLiveStream === '1' && action.payload.live_stream ? { live_stream: JSON.stringify(action.payload.live_stream) } : { live_stream: [] }),
                    organizer_live_stream: action.payload.optionLiveStream,
                    payment_method: action.payload.payment_method,
                    occupation_name: action.payload.occupationName,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.EditCompanyReceived({
            response,
            event_name: action.payload.event_name,
            company_id: action.payload.company_id,
        }));
    } catch (error) {
        yield put(Actions.EditCompanyReceiveFailure(yield error));
    }
}
function* deleteDetailCompany(action) {
    const credential = yield call(waitAuthorizedCheck);
    try {
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/organizer/${action.payload.company_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.DeleteCompanyReceived(response));
    } catch (error) {
        yield put(Actions.DeleteCompanyReceiveFailure(yield error));
    }
}

function* getListSeminarManagement(action) {
    const credential = yield call(waitAuthorizedCheck);
    try {
        const response = yield call(
            API.get, {
                endpoint: `/api/v1/company/${action.payload.company_id}/seminar/`,
                token: credential.data.token,
                body: {
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                },
            },
        );
        yield put(Actions.GetListSeminarReceived(response));
    } catch (error) {
        yield put(Actions.GetListSeminarReceivedFailure(yield error));
    }
}

function* getDetailSeminar(action) {
    const credential = yield call(waitAuthorizedCheck);
    const endpoint = `/api/v1/company/${action.payload.company_id}/seminar/${action.payload.seminar_id}/`;
    try {
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailSeminarReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarReceivedFailure(yield error));
    }
}

function* updateSeminar(action) {
    const credential = yield call(waitAuthorizedCheck);
    const endpoint = `/api/v1/company/${action.payload.company_id}/seminar/${action.payload.seminar_id}/`;
    const [uploadPromise, channel] = createUploaderChannel(action.payload, credential.data.token, endpoint);
    yield fork(uploadProgressWatcher, channel);
    try {
        const response = yield call(() => uploadPromise);

        yield put(Actions.UpdateSeminarReceived(response));
    } catch (error) {
        yield put(Actions.UpdateSeminarReceivedFailure(yield error));
    }
}

function createUploaderChannel(payload, token, endpoint) {
    let emit;
    const chan = eventChannel((emitter) => {
        emit = emitter;
        // it's necessarily. event channel should
        // return unsubscribe function. In our case
        // it's empty function
        return () => {};
    });

    const onProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        emit(percentCompleted);
        if (percentCompleted === 100) emit(END); // 100 percent emit end
        else emit(percentCompleted);
    };

    const uploadPromise = API.putWithFile({
        endpoint,
        body: payload.data,
        token,
        onProgress,
    });

    return [uploadPromise, chan];
}
function* uploadProgressWatcher(channel) {
    while (true) {
        const progress = yield take(channel);
        yield put(Actions.UpdateSeminarProgess(progress));
    }
}

function* getListProductExhibition(action) {
    const credential = yield call(waitAuthorizedCheck);

    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/company/${action.payload.companyID}/product/`,
                body: action.payload.params,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetListProductExhibitionReceived(response));
    } catch (error) {
        yield put(Actions.GetListProductExhibitionReceiveFailure(yield error));
    }
}

function* getDetailProductExhibition(action) {
    const credential = yield call(waitAuthorizedCheck);

    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/company/${action.payload.company_id}/product/${action.payload.product_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailProductExhibitionReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailProductExhibitionReceiveFailure(yield error));
    }
}

function* editProductExhibition(action) {
    const credential = yield call(waitAuthorizedCheck);

    try {
        const response = yield call(
            API.putWithFile,
            {
                endpoint: `/api/v1/company/${action.payload.company_id}/product/${action.payload.product_id}/`,
                body: {
                    ...(action.payload.media && { media: action.payload.media }),
                    ...(!_.isUndefined(action.payload.mediaType) && { media_type: action.payload.mediaType }),
                    ...(action.payload.productName && { name: action.payload.productName }),
                    ...(action.payload.productName && { name_en: action.payload.productNameEN }),
                    ...(action.payload.productDescription && { description: action.payload.productDescription }),
                    ...(action.payload.productDescriptionEN && { description_en: action.payload.productDescriptionEN }),
                    purchase_link: action.payload.purchaseLink,
                    business_contact: action.payload.business_contact,
                    document_link: action.payload.documentRequestReception,
                    survey_link: action.payload.survey,
                    has_outside_link: action.payload.has_outside_link,
                    outside2_link: action.payload.externalLink2,
                    outside3_link: action.payload.externalLink3,
                    ...(action.payload.document && { document: action.payload.document }),
                    price: action.payload.price ? action.payload.price : 0,
                    ...(!_.isUndefined(action.payload.available) && { available: action.payload.available }),
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.EditProductExhibitionReceived(response));
    } catch (error) {
        yield put(Actions.EditProductExhibitionReceiveFailure(yield error));
    }
}

function* deleteProductExhibition(action) {
    const credential = yield call(waitAuthorizedCheck);

    try {
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/company/${action.payload.company_id}/product/${action.payload.product_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.DeleteProductExhibitionReceived(response));
    } catch (error) {
        yield put(Actions.DeleteProductExhibitionReceiveFailure(yield error));
    }
}

function* deleteSeminarOfcompany(action) {
    const credential = yield call(waitAuthorizedCheck);
    try {
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/company/${action.payload.company_id}/seminar/${action.payload.seminar_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.callApiDeleteSeminarOfCompanyReceived(response));
    } catch (error) {
        yield put(Actions.callApiDeleteSeminarOfCompanyReceivedFailure(yield error));
    }
}

function* getDetailCompanyForSideBar(action) {
    const credential = yield call(waitAuthorizedCheck);

    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/organizer/${action.payload.company_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailCompanyForSidebarReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailCompanyForSidebarReceiveFailure(yield error));
    }
}

export default function* AdminEventManagement() {
    yield all([
        takeLatest('GET_LIST_SEMINAR_ADMIN_REQUESTED', getListSeminarManagement),
        takeLatest('GET_DETAIL_SEMINAR_ADMIN_REQUESTED', getDetailSeminar),
        takeLatest('GET_DETAIL_COMPANY_REQUESTED', getDetailCompany),
        takeLatest('EDIT_COMPANY_REQUESTED', editDetailCompany),
        takeLatest('DELETE_COMPANY_REQUESTED', deleteDetailCompany),
        takeLatest('UPDATE_SEMINAR_ADMIN_REQUESTED', updateSeminar),
        takeLatest('GET_LIST_PRODUCT_EXHIBITION_REQUESTED', getListProductExhibition),
        takeLatest('GET_DETAIL_PRODUCT_EXHIBITION_REQUESTED', getDetailProductExhibition),
        takeLatest('EDIT_PRODUCT_EXHIBITION_REQUESTED', editProductExhibition),
        takeLatest('DELETE_PRODUCT_EXHIBITION_REQUESTED', deleteProductExhibition),
        takeLatest('CALL_API_DELETE_SEMINAR_OF_COMPANY', deleteSeminarOfcompany),
        takeLatest('GET_DETAIL_COMPANY_FOR_SIDEBAR_REQUESTED', getDetailCompanyForSideBar),
        takeLatest('EDIT_COMPANY_RECEIVED', getDetailCompanyForSideBar),
    ]);
}
